import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { Event, EventHandler, NoBubblesEventInit } from "@cervval.js/client-html5-core/src/components/event.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { FLEX_CONTAINER, H_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CjsSmartSelect } from "../../smartSelect/smartSelect";
import { i18n, I18nType } from "./i18n/i18n";
import { ensureLoaded } from "@cervval.js/common/src/tools/object.tools";
import { AgendaMode } from "@cervval.js/common/src/tools/timestamps.tools";

ensureLoaded(CjsSmartSelect);

export interface AgendaSelectorOptions {
    mode: AgendaMode;

    modesDisabled?: AgendaMode[];
}

export const defaultAgendaSelectorOptions: AgendaSelectorOptions = {
    mode: "day"
};

@CustomElement({
    name: "cjs-agenda-selector",
    style: require("./agendaSelector.scss"),
    elementCssClasses: [FLEX_CONTAINER, H_100],
    doNotRefreshAfterInit: true,
    i18n
})
export class CjsAgendaSelector extends WebComponent<I18nType> {

    /** Key of "dateChangedAndNeedRefreshData" event from date navigation component */
    @Event(NoBubblesEventInit)
    public selectedModeChangeEvent!: EventHandler<AgendaMode>;

    @TypedWebComponentOptions(defaultAgendaSelectorOptions)
    public readonly options!: WebComponentOptions<AgendaSelectorOptions>;

    public selector = new CjsSmartSelect<AgendaMode, AgendaMode>();

    /** All modes available */
    protected readonly ALL_MODES: AgendaMode[] = ["day", "week", "month"];

    constructor(options?: Partial<AgendaSelectorOptions>) {
        super();
        this.options.setWithoutRefresh(options);
    }

    /** @override */
    public override init(): void {
        this.append(this.selector);

        this.selector.options.setWithoutRefresh({
            selectedValue: "day",
            data: this.ALL_MODES,// TODO Add other options if needed
            itemFormatter: item => this.i18n[item],
            filterDisabled: true,
            callbacksToOverride: {
                getItemValue: item => item
            },
            popup: {
                offset: [1, 5]
            }
        });

        this.selector.smartListOptions.setAndRefreshIfChanged({
            smart: false
        });

        this._initListeners();
    }

    /** @inheritdoc */
    public override refresh(): void {
        this.selector.options.setWithoutRefresh({
            selectedValue: this.options.mode,
            data: this.ALL_MODES.filter(m => !this.options.modesDisabled?.includes(m))
        });
        this.selector.refresh();
    }

    /** @inheritdoc */
    protected _initListeners(): void {
        this.selector.selectEvent.on(e => {
            const value = e.detail.value;
            if (value == null) { return; }
            this.selectedModeChangeEvent.emit(value);

            this.options.setWithoutRefresh({mode: value});
        });

    }

}